import {formatMoney} from '@shopify/theme-currency';

const selectors = {
  cartMessage: '[data-cart-message]',
  cartMessageValue: 'data-cart-message',
  leftToSpend: '[data-left-to-spend]',
  cartProgress: '[data-cart-progress]',
};

const classes = {
  isHidden: 'is-hidden',
  isSuccess: 'is-success',
};

class CartShippingMessage {
  constructor(section) {
    this.container = section;
    this.cartMessage = this.container.querySelectorAll(selectors.cartMessage);
    if (this.cartMessage.length > 0) {
      this.init();
    }
  }

  init() {
    this.cartFreeLimitShipping = Number(this.cartMessage[0].getAttribute('data-limit')) * 100;
    this.shippingAmount = 0;
    this.circumference = 28 * Math.PI; // radius - stroke * 4 * PI

    this.cartBarProgress();
    this.listen();
  }

  listen() {
    document.addEventListener(
      'theme:cart:change',
      function (event) {
        this.cart = event.detail.cart;
        this.render();
      }.bind(this)
    );
  }

  render() {
    if (this.cart && this.cart.total_price) {
      const totalPrice = this.cart.total_price;
      this.freeShippingMessageHandle(totalPrice);

      // Build cart again if the quantity of the changed product is 0 or cart discounts are changed
      if (this.cartMessage.length > 0) {
        this.shippingAmount = totalPrice;
        this.updateProgress();
      }
    }
  }

  freeShippingMessageHandle(total) {
    if (this.cartMessage.length > 0) {
      this.container.querySelectorAll(selectors.cartMessage).forEach((message) => {
        const hasFreeShipping = message.hasAttribute(selectors.cartMessageValue) && message.getAttribute(selectors.cartMessageValue) === 'true' && total !== 0;
        const cartMessageClass = hasFreeShipping ? classes.isSuccess : classes.isHidden;

        message.classList.toggle(cartMessageClass, total >= this.cartFreeLimitShipping);
      });
    }
  }

  cartBarProgress(progress = null) {
    this.container.querySelectorAll(selectors.cartProgress).forEach((element) => {
      this.setProgress(element, progress === null ? element.getAttribute('data-percent') : progress);
    });
  }

  setProgress(holder, percent) {
    const offset = this.circumference - ((percent / 100) * this.circumference) / 2;

    holder.style.strokeDashoffset = offset;
  }

  updateProgress() {
    const newPercentValue = (this.shippingAmount / this.cartFreeLimitShipping) * 100;
    const leftToSpend = formatMoney(this.cartFreeLimitShipping - this.shippingAmount, theme.moneyFormat);

    this.container.querySelectorAll(selectors.leftToSpend).forEach((element) => {
      element.innerHTML = leftToSpend.replace('.00', '');
    });

    this.cartBarProgress(newPercentValue > 100 ? 100 : newPercentValue);
  }
}

export {CartShippingMessage};
